// import "./bootstrap";

import Alpine from "alpinejs";
import UI from "@alpinejs/ui";
// import Mask from "@alpinejs/mask";
import Intersect from "@alpinejs/intersect";
// import Persist from "@alpinejs/persist";
import Focus from "@alpinejs/focus";
import Collapse from "@alpinejs/collapse";
// import Morph from "@alpinejs/morph";

Alpine.plugin(UI);
// Alpine.plugin(Mask);
Alpine.plugin(Intersect);
// Alpine.plugin(Persist);
Alpine.plugin(Focus);
Alpine.plugin(Collapse);
// Alpine.plugin(Morph);

window.Alpine = Alpine;

Alpine.start();

// import $ from "jquery";
// window.$ = window.jQuery = $;

import LazyLoad from "vanilla-lazyload";

new LazyLoad({});
